<div class="w-full">
  <form [formGroup]="form">
    @switch (true) {
      @case (hasSelectableValues()) {
        <div avsRestrictedEl>
          <div class="flex flex-row">
            <mat-form-field
              class="select-classic w-full"
              appearance="outline"
            >
              <mat-select
                class="capitalize"
                formControlName="value"
                panelClass="single-select-overlay"
              >
                @for (value of dropdownValues(); track value) {
                  <mat-option
                    class="capitalize"
                    [value]="value"
                  >
                    {{ (value === '' ? 'empty' : value) }}
                  </mat-option>
                }

              </mat-select>
              <mat-icon
                class="arrow-down"
                matSuffix
              >
                keyboard_arrow_down
              </mat-icon>
              <mat-error>Input is not valid</mat-error>
            </mat-form-field>
          </div>
        </div>
      }
      @case (hasPresetValue()) {
        Remote action will be executed with a value:
        <strong>{{ actionPoint()!.valueValidationRule!.values }}</strong>
      }
      @case (usesSlider()) {
        <div class="flex">
          <avs-slider
            class="mx-auto"
            (valueChanged)="patchValue($event.toString())"
            [max]="actionPoint()!.valueValidationRule?.max||0"
            [min]="actionPoint()!.valueValidationRule?.min||0"
            [step]="actionPoint()!.valueValidationRule?.step||1"
            [value]="actionPoint()!.valueValidationRule?.min||0"
          />
        </div>
      }
      @default {
        <mat-form-field
          class="input-classic w-full"
          appearance="outline"
        >
          <input
            [placeholder]="placeholderText()"
            [type]="isNumericType() ? 'number' : 'text'"
            formControlName="value"
            matInput
          />
        </mat-form-field>
      }
    }
  </form>
</div>
